module.exports = __webpack_public_path__ + "static/img/FRE.9fed175.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FRE.svg
// module id = 0/kA
// module chunks = 1